import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'
import styles from './PostHeader.module.css'

export interface PostHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
	title?: ReactNode
	desc?: ReactNode
	right?: ReactNode
}

export default function PostHeader({
	title,
	desc,
	right,
	children,
	className,
	...props
}: PostHeaderProps) {
	return (
		<header className={clsx(styles.header, className)} {...props}>
			<div className={styles.titleContainer}>
				<div className={styles.title}>{title}</div>
				<div className={styles.desc}>{desc}</div>
			</div>

			<div className={styles.right}>{right}</div>
		</header>
	)
}
